import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Home, Search, User } from 'lucide-react';

const NAV_ITEMS = [
  { id: 'home', label: 'Home', icon: Home, path: '/' },
  { id: 'explore', label: 'Explore', icon: Search, path: '/explore' },
  { id: 'profile', label: 'Profile', icon: User, path: '/profile' },
];

// Routes where bottom nav should be hidden
const HIDDEN_ROUTES = ['/venue/', '/community/', '/admin', '/superadmin'];

const BottomNav = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // Hide on booking pages and specific routes
  const shouldHide = HIDDEN_ROUTES.some(route => location.pathname.startsWith(route))
    || location.pathname.startsWith('/book');
  if (shouldHide) return null;

  const getActiveTab = () => {
    if (location.pathname === '/') return 'home';
    if (location.pathname === '/explore') return 'explore';
    if (location.pathname === '/profile' || location.pathname === '/my-bookings') return 'profile';
    return 'home';
  };

  const activeTab = getActiveTab();

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 bg-white/90 backdrop-blur-xl border-t border-slate-100 z-50 pb-safe md:hidden"
      style={{ boxShadow: '0 -4px 20px rgb(0 0 0 / 0.05)' }}
      data-testid="bottom-navigation"
    >
      <div className="flex items-center justify-around h-16 max-w-md mx-auto">
        {NAV_ITEMS.map(item => {
          const isActive = activeTab === item.id;
          const Icon = item.icon;
          return (
            <button
              key={item.id}
              onClick={() => navigate(item.path)}
              className={`flex flex-col items-center justify-center gap-0.5 w-16 py-1 transition-all duration-200 ${
                isActive ? 'scale-110' : ''
              }`}
              data-testid={`bottom-nav-${item.id}`}
            >
              <Icon
                className={`w-5 h-5 transition-colors ${
                  isActive ? 'text-[#0A2C93]' : 'text-[#737373]'
                }`}
                strokeWidth={isActive ? 2.5 : 2}
              />
              <span
                className={`text-[10px] font-heading font-semibold transition-colors ${
                  isActive ? 'text-[#0A2C93]' : 'text-[#737373]'
                }`}
              >
                {item.label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};

export default BottomNav;
